import { motion } from "motion/react";
import PrayerTimingList from "@/components/panels/PrayerTimingList";
import { panelClassName } from "@/lib/constants";
import type { PrayerLocation, PrayerSnapshot } from "@/types/prayer";

type TodayPanelProps = {
  location: PrayerLocation | null;
  snapshot: PrayerSnapshot | null;
};

const TodayPanel = ({ location, snapshot }: TodayPanelProps) => (
  <motion.div
    animate={{ opacity: 1, x: 0 }}
    className={panelClassName}
    initial={{ opacity: 0, x: -20 }}
    transition={{ duration: 0.4 }}
  >
    <div className="shrink-0 border-b border-zinc-800/50 px-5 pt-5 pb-4">
      <h2 className="text-lg font-semibold text-zinc-100">Today's Timings</h2>
      <p className="mt-1 text-xs text-zinc-500">
        A read-only daily schedule for the selected city, formatted in its local timezone.
      </p>
    </div>

    {!location || !snapshot ? (
      <div className="px-5 py-4 text-sm text-zinc-400">Select a city to inspect today's timings.</div>
    ) : (
      <div className="flex-1 overflow-y-auto px-5 py-4">
        <div className="flex flex-wrap items-center gap-2 text-xs uppercase tracking-wide text-zinc-400">
          <span className="rounded-full bg-white/10 px-3 py-1 font-semibold text-zinc-100">{snapshot.dateLabel}</span>
          <span className="rounded-full bg-white/5 px-3 py-1 font-medium text-zinc-300">{location.city}</span>
          <span className="rounded-full bg-white/5 px-3 py-1 font-medium text-zinc-500">{snapshot.timezoneLabel}</span>
        </div>

        <div className="mt-4">
          <PrayerTimingList activeEvent={snapshot.activeEvent} timings={snapshot.timings} />
        </div>
      </div>
    )}
  </motion.div>
);

export default TodayPanel;
